export default window.onload = (className = "preload") => {
    if (typeof className === 'string' || className instanceof String) {
        document.body.classList.remove(className);
    }
}